import { BaseClass } from './BaseClass';
import { PERMISSIONS } from './Permissions';

export class Campaigns extends BaseClass {
  Promotions: BaseClass;
  Discounts: BaseClass;
  Referral: BaseClass;
  Announcements: BaseClass;
  Notifications: BaseClass;
  constructor(obj: any = PERMISSIONS.Campaigns) {
    super(obj);
    this.Promotions = new BaseClass(obj.Promotions);
    this.Discounts = new BaseClass(obj.Discounts);
    this.Referral = new BaseClass(obj.Referral);
    this.Announcements = new BaseClass(obj.Announcements);
    this.Notifications = new BaseClass(obj.Notifications);
  }
}
